import BehaviorConfig from '@/models/app-config/behavior/behavior'
import ContactLensFKURepository from '@/models/item/fku/repository'
import ContactLensRootRepository from '@/models/item/root/repository'
import { UsualPowerService } from '@/services/api/usual-power/usual-power'
import { createDefaultInitSkuStrategy } from './init-sku-strategy'
import ContactLensItemDetailStore from './store'

export default class ContactLensItemDetailStoreBuilder {
  /**
   * @deprecated
   * 既存のコードが複数箇所からこのファクトリメソッドを利用しているが、良いコードとは言えないので、今後改善の余地ありという意味でdeprecatedにしておく。
   * 理由は以下の通り。
   * 1)カラコン商品詳細画面を構成する複数コンポーネントからこのファクトリが呼ばれているが、そもそもそれら複数コンポーネントを一つの親コンポーネントの中に束ねて、
   * 親コンポーネントで一度だけ状態管理用のストアを生成すればよい。そうすれば、このファクトリやbuildメソッドでシングルトンを考慮する必要がない。
   * ひとつの親コンポーネントにまとめにくい場合は、各コンポーネントから呼ぶことのできるvuexストア類似のものを用意することに意味はあるが、このケースはそうではなさそう。
   *
   * 2)複数コンポーネントからシングルトンとして呼ぶにしても、呼び方が複雑なため改良の余地がある。
   * とくに異なるrootRepo, fkuRepoで複数箇所からgetInstanceが呼ばれた場合、どのシングルトンが生成されるのか把握が困難になる。
   */
  static getInstance(
    rootRepo: ContactLensRootRepository,
    fkuRepo: ContactLensFKURepository,
    usualPowerService: UsualPowerService
  ): ContactLensItemDetailStoreBuilder {
    if (ContactLensItemDetailStoreBuilder.instance === null) {
      ContactLensItemDetailStoreBuilder.instance =
        new ContactLensItemDetailStoreBuilder(rootRepo, fkuRepo, usualPowerService)
    }

    return ContactLensItemDetailStoreBuilder.instance
  }

  private static instance: ContactLensItemDetailStoreBuilder | null = null

  private callback: Promise<ContactLensItemDetailStore> | null = null

  private constructor(
    private readonly rootRepo: ContactLensRootRepository,
    private readonly fkuRepo: ContactLensFKURepository,
    private readonly usualPowerService: UsualPowerService
  ) {}

  async build(
    rootId: string,
    behavior: BehaviorConfig,
    initialSelectedFkuId: string
  ): Promise<ContactLensItemDetailStore> {
    if (this.callback !== null) return this.callback

    this.callback = (async () => {
      const [root, fkus, usualPowerResult] = await Promise.all([
        this.rootRepo.fetch(rootId),
        this.fkuRepo.listBelongingToRoot(rootId),
        this.usualPowerService.getUserInfo(),
      ])

      const store = new ContactLensItemDetailStore(
        root,
        fkus,
        behavior,
        createDefaultInitSkuStrategy(usualPowerResult)
      )

      store.init(initialSelectedFkuId)

      return store
    })()

    return this.callback
  }
}
